import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import Select from 'react-select'
import DatePicker from "react-datepicker"
import { Modal } from 'react-bootstrap'

import { httpOk, GET, POST } from 'helpers/api'
import { formatDate } from 'helpers/helpers'
import GeofenceModal from './GeofenceModal'
import EmployeeMonthModal from './EmployeeMonthModal'
import ReviewModal from './ReviewModal'

const IMG_BASE = process.env.NODE_ENV === 'production'
	? (process.env.REACT_APP_API_URL || 'https://backend.tameer.uz/api').replace(/\/api$/, '')
	: 'http://127.0.0.1:8000'

const WEEKDAYS = [
	{ n: 1, key: 'monday' },
	{ n: 2, key: 'tuesday' },
	{ n: 3, key: 'wednesday' },
	{ n: 4, key: 'thursday' },
	{ n: 5, key: 'friday' },
	{ n: 6, key: 'saturday' },
	{ n: 0, key: 'sunday' },
]

// Ishlagan vaqt "HH:MM" — daqiqa BACKENDDAN keladi.
// Ilgari bu yerda JS da qayta hisoblanardi; qoida SQLda o'zgarsa (masalan tushlik
// ayirilsa) ikki joy har xil raqam ko'rsatib qolar edi.
function durationOf(minutes) {
	if (minutes === null || minutes === undefined) return '--:--'
	const m = Number(minutes)
	if (!m || m < 0) return '--:--'
	return `${String(Math.floor(m / 60)).padStart(2, '0')}:${String(m % 60).padStart(2, '0')}`
}
const timeOnly = (dt) => dt ? formatDate(dt, 'HH:mm') : '--:--'

// Daqiqa → "7s 45d" (jadvalda joy kam)
function hmShort(mins) {
	const m = Number(mins || 0)
	if (!m) return '0'
	const h = Math.floor(m / 60)
	const r = m % 60
	if (!h) return `${r}d`
	return r ? `${h}s ${r}d` : `${h}s`
}

function StatCard({ label, value, color, bg, icon }) {
	return (
		<div className="col-6 col-lg-3 mb-3">
			<div className="card h-100" style={{ background: bg, border: 'none' }}>
				<div className="card-body d-flex justify-content-between align-items-center">
					<div>
						<div className="small" style={{ color }}>{label}</div>
						<div className="fs-3 fw-bold" style={{ color }}>{value}</div>
					</div>
					<span className="d-flex align-items-center justify-content-center"
						style={{ width: 42, height: 42, borderRadius: '50%', background: 'var(--dk-surface, #fff)' }}>
						<i className={icon} style={{ color, fontSize: 20 }}></i>
					</span>
				</div>
			</div>
		</div>
	)
}

function Attendance() {
	const { t } = useTranslation()

	const [tab, setTab] = useState('daily')
	const [departments, setDepartments] = useState([])
	const [departmentId, setDepartmentId] = useState(null)

	const [date, setDate] = useState(new Date())
	const [rows, setRows] = useState([])

	const [month, setMonth] = useState(formatDate(new Date(), 'yyyy-MM'))
	const [monthly, setMonthly] = useState(null)

	const [showManual, setShowManual] = useState(false)
	const [manual, setManual] = useState({ employee_id: null, work_date: new Date(), check_in: '', check_out: '', note: '' })

	const [restDays, setRestDays] = useState([0])
	const [restModal, setRestModal] = useState({ show: false, days: [0] })
	const [showGeofence, setShowGeofence] = useState(false)

	// Korxona ish vaqti — kechikish shu asosda hisoblanadi
	const [workTime, setWorkTime] = useState({ start: '08:00', end: '18:00', tolerance: 0, norm: 600 })
	const [wtModal, setWtModal] = useState({ show: false, start: '08:00', end: '18:00', tolerance: 0 })

	// Xodimning oylik hisoboti (ism ustiga bosilganda)
	const [empModal, setEmpModal] = useState({ show: false, id: null })

	// Chiqish vaqti yozilmagan / xato kunlar
	const [showReview, setShowReview] = useState(false)

	async function loadWorkTime() {
		const res = await GET('/attendance/work-time')
		if (httpOk(res)) setWorkTime(res.data)
	}

	async function saveWorkTime() {
		const res = await POST('/attendance/work-time', {
			start: wtModal.start, end: wtModal.end, tolerance: Number(wtModal.tolerance) || 0,
		}, { loader: true })
		if (httpOk(res)) {
			setWorkTime(res.data)
			setWtModal({ ...wtModal, show: false })
			// Kechikish qayta hisoblanishi uchun joriy ko'rinishni yangilaymiz
			if (tab === 'daily') loadDaily(); else loadMonthly()
		}
	}

	async function loadRestDays() {
		const res = await GET('/attendance/rest-days')
		if (httpOk(res)) setRestDays(res.data.rest_days || [0])
	}

	async function saveRestDays() {
		const res = await POST('/attendance/rest-days', { rest_days: restModal.days }, { loader: true })
		if (httpOk(res)) {
			setRestDays(restModal.days)
			setRestModal({ ...restModal, show: false })
		}
	}

	function toggleRestDay(n) {
		const days = restModal.days.includes(n)
			? restModal.days.filter(x => x !== n)
			: [...restModal.days, n]
		setRestModal({ ...restModal, days })
	}

	async function loadDepartments() {
		const res = await GET('/helper/departments')
		if (httpOk(res)) setDepartments(res.data)
	}

	async function loadDaily() {
		const params = { date: formatDate(date, 'yyyy-MM-dd') }
		if (departmentId) params.department_id = departmentId
		const res = await GET('/attendance', params, { loader: true })
		if (httpOk(res)) {
			setRows(res.data.data)
			if (res.data.work_time) setWorkTime(res.data.work_time)
		}
	}

	async function loadMonthly() {
		const params = { month }
		if (departmentId) params.department_id = departmentId
		const res = await GET('/attendance/monthly', params, { loader: true })
		if (httpOk(res)) {
			setMonthly(res.data)
			if (res.data.work_time) setWorkTime(res.data.work_time)
		}
	}

	// Mavjud xodimni bosganda — kirish/chiqish vaqti to'ldirilган holda ochamiz
	function openEdit(row) {
		setManual({
			employee_id: row.id,
			work_date: date,
			check_in: row.check_in_at ? formatDate(row.check_in_at, 'HH:mm') : '',
			check_out: row.check_out_at ? formatDate(row.check_out_at, 'HH:mm') : '',
			note: row.note || '',
		})
		setShowManual(true)
	}

	async function saveManual(e) {
		e.preventDefault()
		const wd = formatDate(manual.work_date, 'yyyy-MM-dd')
		const res = await POST('/attendance', {
			employee_id: manual.employee_id,
			work_date: wd,
			check_in_at: manual.check_in ? `${wd} ${manual.check_in}:00` : null,
			check_out_at: manual.check_out ? `${wd} ${manual.check_out}:00` : null,
			status: 'present',
			note: manual.note,
		}, { loader: true })
		if (httpOk(res)) {
			setShowManual(false)
			setManual({ employee_id: null, work_date: date, check_in: '', check_out: '', note: '' })
			loadDaily()
		}
	}

	useEffect(() => { loadDepartments(); loadRestDays(); loadWorkTime() }, [])

	useEffect(() => {
		if (tab === 'daily') loadDaily()
		else loadMonthly()
	}, [tab, date, month, departmentId]) // eslint-disable-line react-hooks/exhaustive-deps

	// Statistika — kechikish endi haqiqiy hisobdan (ilgari doim 0 edi)
	const total = rows.length
	const atWork = rows.filter(r => r.check_in_at).length
	const late = rows.filter(r => Number(r.late_minutes) > 0).length
	const absent = total - atWork

	// Oylik grid — endi butun yozuv saqlanadi (yarim kun/kechikish uchun kerak)
	const monthMap = {}
	if (monthly) {
		monthly.attendances.forEach(a => {
			const day = Number(String(a.work_date).slice(8, 10))
			monthMap[`${a.employee_id}_${day}`] = a
		})
	}
	const days = monthly ? Array.from({ length: monthly.days_in_month }, (_, i) => i + 1) : []

	// Tekshirish kerak bo'lgan kunlar soni — jamlanmadan olinadi (qayta sanamaymiz)
	const reviewCount = monthly
		? Object.values(monthly.totals || {}).reduce(
			(s, t) => s + Number(t.incomplete_days || 0) + Number(t.invalid_days || 0), 0)
		: 0

	function isWeekend(d) {
		const [y, m] = month.split('-')
		const dow = new Date(Number(y), Number(m) - 1, d).getDay()
		return restDays.includes(dow)
	}

	return (
		<>
			<div className="page-header d-flex justify-content-between align-items-center flex-wrap gap-2">
				<div className="d-flex align-items-center gap-3">
					<h4 className="mb-0">{t('attendance')}</h4>
					<div className="btn-group">
						<button className={`btn btn-sm ${tab === 'daily' ? 'btn-primary' : 'btn-outline-primary'}`}
							onClick={() => setTab('daily')}>{t('att_daily')}</button>
						<button className={`btn btn-sm ${tab === 'monthly' ? 'btn-primary' : 'btn-outline-primary'}`}
							onClick={() => setTab('monthly')}>{t('att_monthly')}</button>
					</div>
				</div>
				<div className="d-flex gap-2 flex-wrap">
					{tab === 'daily' ? (
						<div style={{ minWidth: '150px' }}>
							<DatePicker className="form-control" selected={date}
								onChange={(d) => setDate(d)} dateFormat="dd.MM.yyyy" maxDate={new Date()} />
						</div>
					) : (
						<div style={{ minWidth: '150px' }}>
							<DatePicker className="form-control" selected={new Date(month + '-01')}
								onChange={(d) => setMonth(formatDate(d, 'yyyy-MM'))}
								dateFormat="MM.yyyy" showMonthYearPicker />
						</div>
					)}
					<div style={{ minWidth: '180px' }}>
						<Select isClearable options={departments}
							value={departments.find(o => o.id === departmentId) || null}
							onChange={(opt) => setDepartmentId(opt ? opt.id : null)}
							placeholder={t('all_departments')}
							getOptionLabel={(o) => o.name} getOptionValue={(o) => o.id} />
					</div>
					{tab === 'daily' &&
						<button className="btn btn-outline-primary"
							onClick={() => { setManual({ employee_id: null, work_date: date, check_in: '', check_out: '', note: '' }); setShowManual(true) }}>
							<i className="uil-plus me-1"></i>{t('manual_attendance')}
						</button>
					}
					{tab === 'monthly' &&
						<button className={`btn ${reviewCount > 0 ? 'btn-warning' : 'btn-outline-secondary'}`}
							onClick={() => setShowReview(true)}>
							<i className="uil-exclamation-triangle me-1"></i>{t('needs_review')}
							{reviewCount > 0 &&
								<span className="badge bg-dark ms-1">{reviewCount}</span>}
						</button>
					}
					{tab === 'monthly' &&
						<button className="btn btn-outline-secondary"
							onClick={() => setRestModal({ show: true, days: [...restDays] })}>
							<i className="uil-calender me-1"></i>{t('rest_days_title')}
						</button>
					}
					<button className="btn btn-outline-secondary"
						onClick={() => setWtModal({ show: true, start: workTime.start, end: workTime.end, tolerance: workTime.tolerance })}>
						<i className="uil-clock me-1"></i>{t('work_time')}
					</button>
					<button className="btn btn-outline-secondary" onClick={() => setShowGeofence(true)}>
						<i className="uil-map-marker me-1"></i>{t('work_location_btn')}
					</button>
				</div>
			</div>

			{tab === 'daily' &&
				<>
					{/* STATISTIKA */}
					<div className="row">
						<StatCard label={t('all')} value={total} color="var(--dk-ok-fg, #0f9d58)" bg="var(--dk-ok-bg, #e6f7ee)" icon="uil-users-alt" />
						<StatCard label={t('at_work')} value={atWork} color="var(--dk-info-fg, #1a73e8)" bg="var(--dk-info-bg, #e8f0fe)" icon="uil-check-circle" />
						<StatCard label={t('late')} value={late} color="var(--dk-warn-fg, #b8860b)" bg="var(--dk-warn-bg, #fef7e0)" icon="uil-clock" />
						<StatCard label={t('not_at_work')} value={absent} color="var(--dk-danger-fg, #d93025)" bg="var(--dk-danger-bg, #fce8e6)" icon="uil-times-circle" />
					</div>

					<div className="card">
						<div className="card-body">
							<div className="d-flex justify-content-between align-items-center mb-3">
								<h6 className="fw-bold mb-0">{t('employees_attendance')}</h6>
								<span className="text-muted" style={{ fontSize: '12.5px' }}>
									{t('work_time')}: <b>{workTime.start}–{workTime.end}</b>
									{workTime.tolerance > 0 && <> · {t('tolerance_short')} {workTime.tolerance} {t('minute')}</>}
								</span>
							</div>
							<div className="table-responsive">
								<table className="table table-borderless mb-0 align-middle">
									<thead>
										<tr className="text-muted small border-bottom">
											<th>{t('employee')}</th>
											<th className="text-center">{t('check_in')}</th>
											<th className="text-center">{t('check_out')}</th>
											<th className="text-center">{t('lateness')}</th>
											<th className="text-center">{t('total')}</th>
											<th>{t('department')}</th>
										</tr>
									</thead>
									<tbody>
										{rows.map((r) => {
											const isLate = Number(r.late_minutes) > 0
											return (
												<tr key={r.id} className="border-bottom cursor" onClick={() => openEdit(r)}>
													<td>
														<div className="d-flex align-items-center gap-2">
															{r.photo
																? <img src={`${IMG_BASE}/uploads/employees/${r.photo}`} alt=""
																	style={{ width: 38, height: 38, borderRadius: '50%', objectFit: 'cover' }} />
																: <span className="d-flex align-items-center justify-content-center"
																	style={{ width: 38, height: 38, borderRadius: '50%', background: 'var(--dk-surface-3, #e9ecef)', fontSize: 13 }}>
																	{r.name?.[0]}
																</span>}
															<div>
																<div className="fw-semibold">{r.name}</div>
																<div className="text-muted small">{r.department_name || '—'}</div>
															</div>
														</div>
													</td>
													<td className="text-center fw-semibold">
														<span className={isLate ? 'text-danger' : ''}>{timeOnly(r.check_in_at)}</span>
													</td>
													<td className="text-center fw-semibold">{timeOnly(r.check_out_at)}</td>
													<td className="text-center">
														{isLate
															? <span className="badge bg-warning text-dark" style={{ fontSize: '10.5px' }}>{hmShort(r.late_minutes)}</span>
															: <span className="text-muted">—</span>}
													</td>
													<td className="text-center fw-bold">
													{r.invalid_times
														? <span className="text-danger" title={t('invalid_time_title')}>{t('error_short')}</span>
														: durationOf(r.worked_minutes)}
												</td>
													<td className="text-muted">{r.department_name}</td>
												</tr>
											)
										})}
										{rows.length === 0 &&
											<tr><td colSpan={6} className="text-center text-muted py-4">{t('list_empty')}</td></tr>
										}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</>
			}

			{/* OYLIK GRID */}
			{tab === 'monthly' && monthly &&
				<div className="card">
					<div className="card-body">
						<div className="table-responsive" style={{ maxHeight: '75vh' }}>
							<table className="table mb-0 text-center" style={{ fontSize: 12, borderCollapse: 'separate', borderSpacing: 0 }}>
								<thead>
									<tr>
										<th style={{ position: 'sticky', left: 0, top: 0, zIndex: 3, background: 'var(--dk-surface-2, #f8f9fa)', minWidth: 170, textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>{t('employee')}</th>
										{days.map(d => {
											const w = isWeekend(d)
											return <th key={d} style={{ position: 'sticky', top: 0, zIndex: 2, minWidth: 30, padding: '6px 2px', background: w ? 'var(--dk-danger-bg, #fdecea)' : 'var(--dk-surface-2, #f8f9fa)', color: w ? '#dc3545' : '#6c757d', borderBottom: '2px solid #dee2e6' }}>{d}</th>
										})}
										<th style={{ position: 'sticky', top: 0, zIndex: 2, minWidth: 55, background: 'var(--dk-surface-2, #f8f9fa)', borderBottom: '2px solid #dee2e6' }}>{t('days_count')}</th>
										<th style={{ position: 'sticky', top: 0, zIndex: 2, minWidth: 70, background: 'var(--dk-surface-2, #f8f9fa)', borderBottom: '2px solid #dee2e6' }}>{t('hours_count')}</th>
									</tr>
								</thead>
								<tbody>
									{monthly.employees.map(e => {
										const tot = (monthly.totals || {})[e.id]
										const dayCount = tot ? Number(tot.days) : 0
										const workedMin = tot ? Number(tot.worked_minutes) : 0
										return (
											<tr key={e.id}>
												<td className="fw-semibold text-nowrap cursor"
													style={{ position: 'sticky', left: 0, zIndex: 1, background: 'var(--dk-surface, #fff)', textAlign: 'left', borderBottom: '1px solid #f0f0f0', color: '#1a73e8' }}
													onClick={() => setEmpModal({ show: true, id: e.id })}
													title={t('click_name_hint')}>
													{e.name}
												</td>
												{days.map(d => {
													const rec = monthMap[`${e.id}_${d}`]
													const w = isWeekend(d)
													const val = rec ? Number(rec.day_value) : 0
													const isLate = rec && Number(rec.late_minutes) > 0
													return (
														<td key={d} title={rec ? `${timeOnly(rec.check_in_at)} – ${timeOnly(rec.check_out_at)}` : ''}
															style={{
																padding: 0, height: 30, borderBottom: '1px solid #f0f0f0',
																background: val === 1 ? 'var(--dk-ok-bg, #e6f7ee)' : (val === 0.5 ? 'var(--dk-warn-bg, #fef7e0)' : (w ? 'var(--dk-weekend-bg, #fdf4f3)' : 'var(--dk-surface, #fff)')),
																position: 'relative',
															}}>
															{val === 1 && <i className="uil-check" style={{ color: '#198754', fontSize: 15 }}></i>}
															{val === 0.5 && <span style={{ color: '#b8860b', fontWeight: 700, fontSize: 12 }}>½</span>}
															{isLate &&
																<span style={{ position: 'absolute', top: 2, right: 2, width: 5, height: 5, borderRadius: '50%', background: '#dc3545' }}></span>}
														</td>
													)
												})}
												<td className="fw-bold" style={{ background: 'var(--dk-surface-2, #f8f9fa)', borderBottom: '1px solid #f0f0f0' }}>{dayCount}</td>
												<td style={{ background: 'var(--dk-surface-2, #f8f9fa)', borderBottom: '1px solid #f0f0f0' }}>{hmShort(workedMin)}</td>
											</tr>
										)
									})}
									{monthly.employees.length === 0 &&
										<tr><td colSpan={days.length + 3} className="text-center text-muted py-3">{t('list_empty')}</td></tr>
									}
								</tbody>
							</table>
						</div>
						<p className="text-muted small mt-2 mb-0">
							<i className="uil-check" style={{ color: '#198754' }}></i> {t('full_day')} ·
							<span style={{ color: '#b8860b', fontWeight: 700 }} className="ms-1">½</span> {t('half_day')} ·
							<span className="ms-1 d-inline-block" style={{ width: 6, height: 6, borderRadius: '50%', background: '#dc3545' }}></span> {t('late')} ·
							<span className="ms-1 d-inline-block" style={{ width: 10, height: 10, background: 'var(--dk-danger-bg, #fdecea)', border: '1px solid #dc3545', borderRadius: 2 }}></span> {t('rest_columns_legend')}
							<span className="ms-2">| {t('click_name_hint')}</span>
						</p>
					</div>
				</div>
			}

			<GeofenceModal show={showGeofence} onClose={() => setShowGeofence(false)} />

			<EmployeeMonthModal
				show={empModal.show}
				employeeId={empModal.id}
				month={month}
				restDays={restDays}
				onClose={() => setEmpModal({ show: false, id: null })} />

			<ReviewModal
				show={showReview}
				month={month}
				onClose={() => setShowReview(false)}
				onSaved={loadMonthly} />

			{/* ISH VAQTI MODAL */}
			<Modal show={wtModal.show} animation={false} centered backdrop="static"
				onHide={() => setWtModal({ ...wtModal, show: false })}>
				<Modal.Header closeButton>
					<Modal.Title style={{ fontSize: '17px' }}>{t('work_time_title')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<p className="text-muted small">
						{t('work_time_hint')}
					</p>
					<div className="row">
						<div className="col-6">
							<div className="form-group">
								<label>{t('work_start_label')}<span className="required-mark">*</span></label>
								<input type="time" className="form-control" value={wtModal.start}
									onChange={(e) => setWtModal({ ...wtModal, start: e.target.value })} />
							</div>
						</div>
						<div className="col-6">
							<div className="form-group">
								<label>{t('work_end_label')}<span className="required-mark">*</span></label>
								<input type="time" className="form-control" value={wtModal.end}
									onChange={(e) => setWtModal({ ...wtModal, end: e.target.value })} />
							</div>
						</div>
					</div>
					<div className="form-group mb-0">
						<label>{t('late_tolerance')}</label>
						<input type="number" className="form-control" min="0" max="240" value={wtModal.tolerance}
							onChange={(e) => setWtModal({ ...wtModal, tolerance: e.target.value })} />
						<small className="text-muted">
							{t('late_tolerance_hint')}
						</small>
					</div>
					<div className="d-flex gap-2 mt-3">
						<button type="button" className="btn btn-outline-warning w-100"
							onClick={() => setWtModal({ ...wtModal, show: false })}>{t('cancel')}</button>
						<button type="button" className="btn btn-primary w-100" onClick={saveWorkTime}>{t('save')}</button>
					</div>
				</Modal.Body>
			</Modal>

			{/* DAM OLISH KUNLARI MODAL */}
			<Modal show={restModal.show} animation={false} centered backdrop="static"
				onHide={() => setRestModal({ ...restModal, show: false })}>
				<Modal.Header closeButton>
					<Modal.Title>{t('rest_days_title')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<p className="text-muted small">{t('rest_days_hint')}</p>
					<div className="d-flex flex-column gap-1">
						{WEEKDAYS.map(w => (
							<label key={w.n} className="d-flex align-items-center justify-content-between p-2 rounded cursor"
								style={{ border: '1px solid #dee2e6' }}>
								<span>{t(w.key)}</span>
								<input type="checkbox" className="form-check-input"
									checked={restModal.days.includes(w.n)}
									onChange={() => toggleRestDay(w.n)} />
							</label>
						))}
					</div>
					<div className="d-flex gap-2 mt-3">
						<button type="button" className="btn btn-outline-warning w-100"
							onClick={() => setRestModal({ ...restModal, show: false })}>{t('cancel')}</button>
						<button type="button" className="btn btn-primary w-100" onClick={saveRestDays}>{t('save')}</button>
					</div>
				</Modal.Body>
			</Modal>

			{/* QO'LDA DAVOMAT MODAL */}
			<Modal show={showManual} animation={false} centered backdrop="static" onHide={() => setShowManual(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('manual_attendance_title')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={saveManual} autoComplete="off">
						<div className="form-group">
							<label>{t('employee')}<span className="required-mark">*</span></label>
							<Select
								options={rows}
								value={rows.find(r => r.id === manual.employee_id) || null}
								onChange={(opt) => setManual({ ...manual, employee_id: opt?.id })}
								placeholder={t('select_employee')}
								getOptionLabel={(o) => o.name} getOptionValue={(o) => o.id} />
						</div>
						<div className="form-group">
							<label>{t('date')}<span className="required-mark">*</span></label>
							<DatePicker className="form-control" selected={manual.work_date}
								onChange={(d) => setManual({ ...manual, work_date: d })}
								dateFormat="dd.MM.yyyy" maxDate={new Date()} />
						</div>
						<div className="row">
							<div className="col-6">
								<div className="form-group">
									<label>{t('check_in_time')}<span className="required-mark">*</span></label>
									<input type="time" className="form-control" value={manual.check_in}
										onChange={(e) => setManual({ ...manual, check_in: e.target.value })} />
								</div>
							</div>
							<div className="col-6">
								<div className="form-group">
									<label>{t('check_out_time')}</label>
									<input type="time" className="form-control" value={manual.check_out}
										onChange={(e) => setManual({ ...manual, check_out: e.target.value })} />
								</div>
							</div>
						</div>
						<div className="form-group mb-0">
							<label>{t('note')}</label>
							<input type="text" className="form-control" value={manual.note}
								onChange={(e) => setManual({ ...manual, note: e.target.value })} />
						</div>
						<small className="text-muted d-block mt-2">
							{t('check_in_required_hint')}
						</small>
						<div className="d-flex gap-2 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => setShowManual(false)}>{t('cancel')}</button>
							<button type="submit" className="btn btn-primary w-100"
								disabled={!manual.employee_id || !manual.check_in}>{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
		</>
	)
}

export default Attendance
